import { render } from "./CreateModal.vue?vue&type=template&id=418a0856&scoped=true"
import script from "./CreateModal.vue?vue&type=script&lang=js"
export * from "./CreateModal.vue?vue&type=script&lang=js"

import "./CreateModal.vue?vue&type=style&index=0&id=418a0856&lang=scss&scoped=true"
import "./CreateModal.vue?vue&type=style&index=1&id=418a0856&lang=css"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418a0856"]])

export default __exports__